import GeneralProduct from './GeneralProduct'

export default GeneralProduct
